const INITIAL_STATE = {
  erro: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CAPTCHA_INVISIVEL_ERRO':
      return { erro: true }
    default:
      return state
  }
  
}
  
